module.exports = __webpack_public_path__ + "static/img/data-analysis.f63a8f76.png";